class PoaDrawer extends Drawer {
  // POAForm. dont use
  /*
  connectedCallback() {
    const poaForm = this.querySelector("#POAForm");

    poaForm.addEventListener("submit", (event) => {
      event.preventDefault();
      this.handlePOAFormSubmit(event);
    });
  }

  handlePOAFormSubmit(event) {
    fetch(event.target.dataset.action, {
      method: "POST",
      body: new FormData(event.target),
    })
      .then((response) => response.text())
      .then((data) => {
        document.querySelector("#poaDrawer .drawer__content").innerHTML = data;
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }
  */
}

customElements.define("poa-drawer", PoaDrawer);

class PoaDrawerButton extends DrawerButton {
  handleClick() {
    let action = this.dataset.action ? this.dataset.action : "open";

    if (action === "open") {
      this.drawer.open();
    } else {
      this.drawer.close();
    }
  }
}

customElements.define("poa-button", PoaDrawerButton);
